import { useMemo } from 'react';
import { useSyncStaticStateInsideIFrame } from 'embedded-academy-lib/insideFrame';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import { getIsStandaloneWidget, getIsStaticPublicUrl } from '../../utils/urls';
export const useStaticContentState = () => {
  const {
    state
  } = useSyncStaticStateInsideIFrame();
  const [searchParams] = useSearchParams();
  const shouldEnablePictureInPicture = useMemo(() => searchParams.enablePictureInPicture ? /^true$/i.test(searchParams.enablePictureInPicture) : undefined, [searchParams.enablePictureInPicture]);
  const isPublicWidget = getIsStaticPublicUrl();
  if (!state && (isPublicWidget || getIsStandaloneWidget())) {
    return {
      authType: isPublicWidget ? 'public' : undefined,
      autoPlay: undefined,
      shortId: searchParams.shortId && Number(searchParams.shortId) || undefined,
      lessonId: searchParams.lessonId && Number(searchParams.lessonId) || undefined,
      contentId: searchParams.contentId && Number(searchParams.contentId) || undefined,
      language: searchParams === null || searchParams === void 0 ? void 0 : searchParams.language,
      variant: searchParams === null || searchParams === void 0 ? void 0 : searchParams.variant,
      startTime: searchParams === null || searchParams === void 0 ? void 0 : searchParams.startTime,
      sectionEndTime: searchParams === null || searchParams === void 0 ? void 0 : searchParams.sectionEndTime,
      Title: undefined,
      renderContext: searchParams.renderContext,
      hublet: searchParams.hublet,
      enablePictureInPicture: shouldEnablePictureInPicture,
      mutedByDefault: undefined,
      linkTextProps: undefined,
      videoWrapperProps: undefined,
      openLinksInNewTab: undefined
    };
  }
  return Object.assign({
    authType: state === null || state === void 0 ? void 0 : state.authType,
    autoPlay: state === null || state === void 0 ? void 0 : state.autoPlay,
    shortId: state === null || state === void 0 ? void 0 : state.shortId,
    lessonId: state === null || state === void 0 ? void 0 : state.lessonId,
    contentId: state === null || state === void 0 ? void 0 : state.contentId,
    language: state === null || state === void 0 ? void 0 : state.language,
    variant: state === null || state === void 0 ? void 0 : state.variant,
    startTime: state === null || state === void 0 ? void 0 : state.startTime,
    sectionEndTime: state === null || state === void 0 ? void 0 : state.sectionEndTime,
    renderContext: state === null || state === void 0 ? void 0 : state.renderContext,
    enablePictureInPicture: state === null || state === void 0 ? void 0 : state.enablePictureInPicture,
    hublet: state === null || state === void 0 ? void 0 : state.hublet,
    mutedByDefault: state === null || state === void 0 ? void 0 : state.mutedByDefault,
    linkTextProps: state === null || state === void 0 ? void 0 : state.linkTextProps,
    videoWrapperProps: state === null || state === void 0 ? void 0 : state.videoWrapperProps,
    openLinksInNewTab: state === null || state === void 0 ? void 0 : state.openLinksInNewTab
  }, (state === null || state === void 0 ? void 0 : state.Title) && {
    Title: state.Title
  });
};